import React, { useRef } from "react";
import PropTypes from "prop-types";
import { DateRangePicker } from "rsuite";
import { beforeToday } from "rsuite/cjs/DateRangePicker/disabledDateUtils";
import { formatDateRange } from "../../../utils/dateUtils";
import SplitDateRangeFields from "./SplitDateRangeFields";
import deleteIcon from "../../../assets/img/delete.svg";

/**
 * BookingWindowSection - Booking window date range picker section
 *
 * When `splitDateFields` is set (promo edit only, HTT-9780) the range picker is
 * replaced by separate Start Date / End Date pickers so an already-started promo
 * can have its end date extended. Defaults to the range picker everywhere else.
 */
function BookingWindowSection({
  fromBooking = null,
  toBooking = null,
  onBookingChange,
  onRemove,
  hasError = false,
  splitDateFields = false,
}) {
  const bookingFromRef = useRef(null);

  return (
    <div className="tc-section condition-form-section">
      <div className="condition-row">
        <span className="condition-label">Booking Window</span>
        {splitDateFields ? (
          <SplitDateRangeFields
            startDate={fromBooking}
            endDate={toBooking}
            onChange={onBookingChange}
            hasError={hasError}
          />
        ) : (
          <div className="condition-input-wrapper">
            <DateRangePicker
              placement={"bottom"}
              value={fromBooking && toBooking ? [fromBooking, toBooking] : null}
              onChange={onBookingChange}
              placeholder="Select date range"
              block
              container={() => bookingFromRef.current}
              renderValue={formatDateRange}
              shouldDisableDate={beforeToday()}
              disableddateStyle={{
                backgroundColor: "#f5f5f5",
                color: "#999",
              }}
              cleanable={false}
              className={hasError ? "input-error" : ""}
            />
            <div className="position-relative" ref={bookingFromRef} />
          </div>
        )}
        <button
          type="button"
          className="remove-condition-btn"
          onClick={onRemove}
        >
          <img src={deleteIcon} alt="Delete" className="delete-icon" />
        </button>
      </div>
    </div>
  );
}

BookingWindowSection.propTypes = {
  fromBooking: PropTypes.instanceOf(Date),
  toBooking: PropTypes.instanceOf(Date),
  onBookingChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  splitDateFields: PropTypes.bool,
};

export default BookingWindowSection;
